"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Divider_1 = __importDefault(require("@material-ui/core/Divider"));
var List_1 = __importDefault(require("@material-ui/core/List"));
var ListItem_1 = __importDefault(require("@material-ui/core/ListItem"));
var ListItemText_1 = __importDefault(require("@material-ui/core/ListItemText"));
var Typography_1 = __importDefault(require("@material-ui/core/Typography"));
var Skeleton_1 = __importDefault(require("@material-ui/lab/Skeleton"));
var react_1 = __importDefault(require("react"));
exports.DropListDetails = function (_a) {
    var loading = _a.loading, amount = _a.amount, email = _a.email, quadkey = _a.quadkey, message = _a.message, title = _a.title, link = _a.link, dailyBudget = _a.dailyBudget, total = _a.total;
    return (react_1.default.createElement(List_1.default, { disablePadding: true },
        react_1.default.createElement(ListItem_1.default, { dense: true },
            react_1.default.createElement(ListItemText_1.default, { primary: "Tile" }),
            react_1.default.createElement(SkeletonTypography, { variant: "body2", loading: loading }, quadkey ? quadkey : 'Any')),
        react_1.default.createElement(Divider_1.default, null),
        react_1.default.createElement(ListItem_1.default, { dense: true },
            react_1.default.createElement(ListItemText_1.default, { primary: "Email" }),
            react_1.default.createElement(SkeletonTypography, { variant: "body2", loading: loading }, email ? email : 'Any')),
        react_1.default.createElement(Divider_1.default, null),
        react_1.default.createElement(ListItem_1.default, { dense: true },
            react_1.default.createElement(ListItemText_1.default, { primary: "Link" }),
            react_1.default.createElement(SkeletonTypography, { variant: "body2", loading: loading }, link ? link : 'None')),
        react_1.default.createElement(Divider_1.default, null),
        react_1.default.createElement(ListItem_1.default, { dense: true },
            react_1.default.createElement(ListItemText_1.default, { primary: "Title" }),
            react_1.default.createElement(SkeletonTypography, { variant: "body2", loading: loading, className: "pl-5", style: { wordBreak: 'break-all' } }, title ? title : 'None')),
        react_1.default.createElement(Divider_1.default, null),
        react_1.default.createElement(ListItem_1.default, { dense: true },
            react_1.default.createElement(ListItemText_1.default, { primary: "Note" }),
            react_1.default.createElement(SkeletonTypography, { variant: "body2", loading: loading, className: "pl-5", style: { wordBreak: 'break-all' } }, message ? message : 'None')),
        react_1.default.createElement(Divider_1.default, null),
        react_1.default.createElement(ListItem_1.default, { dense: true },
            react_1.default.createElement(ListItemText_1.default, { primary: "Amount" }),
            react_1.default.createElement(SkeletonTypography, { variant: "body2", loading: loading }, amount)),
        react_1.default.createElement(Divider_1.default, null),
        dailyBudget ? (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(ListItem_1.default, null,
                react_1.default.createElement(ListItemText_1.default, { primary: react_1.default.createElement("strong", null, "Daily Budget") }),
                react_1.default.createElement(SkeletonTypography, { variant: "body2", loading: loading }, dailyBudget)),
            react_1.default.createElement(Divider_1.default, null))) : null,
        total ? (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(ListItem_1.default, null,
                react_1.default.createElement(ListItemText_1.default, { primary: react_1.default.createElement("strong", null, "Total") }),
                react_1.default.createElement(SkeletonTypography, { variant: "body2", loading: loading }, total)),
            react_1.default.createElement(Divider_1.default, null))) : null));
};
var SkeletonTypography = function (_a) {
    var loading = _a.loading, children = _a.children, props = __rest(_a, ["loading", "children"]);
    return loading ? (react_1.default.createElement(Skeleton_1.default, { variant: "text", width: 40, classes: { animate: 'skeleton' }, style: {
            backgroundColor: 'rgba(0, 0, 0, 0.2)',
            margin: 0,
        } })) : (react_1.default.createElement(Typography_1.default, __assign({}, props), children));
};
//# sourceMappingURL=index.js.map